import React from 'react';

const AuthLeftPanel = () => {
    return (
        <div className="w-full lg:w-1/2 cinematic-gradient relative p-12 lg:p-16 hidden lg:flex flex-col justify-between overflow-hidden order-first">
            <div className="absolute top-0 right-0 w-96 h-96 bg-cyan/5 rounded-full blur-[100px] pointer-events-none translate-x-1/2 -translate-y-1/2"></div>
            <div className="absolute bottom-0 left-0 w-80 h-80 bg-cyan/5 rounded-full blur-[80px] pointer-events-none -translate-x-1/3 translate-y-1/3"></div>
            <div className="relative z-10">
                <div className="flex items-center gap-2 mb-12">
                    <span className="material-symbols-outlined text-cyan text-4xl filled">bolt</span>
                    <h1 className="text-2xl font-bold tracking-tight text-white">OffTrigger</h1>
                </div>
                <div className="space-y-8 max-w-lg text-left">
                    <h2 className="text-4xl lg:text-5xl font-bold text-white leading-tight text-left">
                        Never Lose Another Lead to <span className="text-cyan">Slow Response Times</span>
                    </h2>
                    <ul className="space-y-4 mt-8">
                        <li className="flex items-center gap-3 text-light/90 text-lg">
                            <span className="flex items-center justify-center w-6 h-6 rounded-full bg-cyan/20 text-cyan">
                                <span className="material-symbols-outlined text-sm font-bold">check</span>
                            </span>
                            Auto-respond in 30 seconds
                        </li>
                        <li className="flex items-center gap-3 text-light/90 text-lg">
                            <span className="flex items-center justify-center w-6 h-6 rounded-full bg-cyan/20 text-cyan">
                                <span className="material-symbols-outlined text-sm font-bold">check</span>
                            </span>
                            WhatsApp + SMS + Email
                        </li>
                        <li className="flex items-center gap-3 text-light/90 text-lg">
                            <span className="flex items-center justify-center w-6 h-6 rounded-full bg-cyan/20 text-cyan">
                                <span className="material-symbols-outlined text-sm font-bold">check</span>
                            </span>
                            Works in 15+ countries
                        </li>
                    </ul>
                </div>
            </div>
            <div className="relative z-10 mt-12 lg:mt-0">
                <div className="flex items-center gap-4 bg-navy/30 backdrop-blur-sm p-4 rounded-xl border border-light/10 w-fit">
                    <div className="flex -space-x-3">
                        <img alt="Agent" className="w-10 h-10 rounded-full border-2 border-navy object-cover" src="https://randomuser.me/api/portraits/women/44.jpg" />
                        <img alt="Agent" className="w-10 h-10 rounded-full border-2 border-navy object-cover" src="https://randomuser.me/api/portraits/men/32.jpg" />
                        <img alt="Agent" className="w-10 h-10 rounded-full border-2 border-navy object-cover" src="https://randomuser.me/api/portraits/women/68.jpg" />
                        <div className="w-10 h-10 rounded-full border-2 border-navy bg-cyan text-navy font-bold text-xs flex items-center justify-center">+100</div>
                    </div>
                    <div className="text-sm">
                        <p className="font-semibold text-white text-left">Trusted by Top agents</p>
                        <div className="flex items-center text-cyan gap-1">
                            <span className="material-symbols-outlined text-base fill-current filled">star</span>
                            <span className="material-symbols-outlined text-base fill-current filled">star</span>
                            <span className="material-symbols-outlined text-base fill-current filled">star</span>
                            <span className="material-symbols-outlined text-base fill-current filled">star</span>
                            <span className="material-symbols-outlined text-base fill-current filled">star</span>
                            <span className="text-light/70 text-xs ml-1">4.9/5 Rating</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default AuthLeftPanel;
